export const SIDE_BAR = "SIDE_BAR"